function ProductCard({ product }) {

  const handleBuyNow = () => {
    window.open(product.amazonLink, "_blank");
  };

  return (
    <div className="card">
      <img src={product.image} alt={product.name} />
      <h3>{product.name}</h3>
      <p className="price">{product.price}</p>

      <button onClick={handleBuyNow}>
        Buy Now 🛒
      </button>
    </div>
  );
}

export default ProductCard;